module.exports = __webpack_public_path__ + "img/cf4DQqkdoEKIumcO.8c266a7c.jpeg";